/**
 * Begin DND decoration
 */
const listItemDragSource = {
  beginDrag: function (props) {
    const { item } = props;

    let { selectedItemIds } = props;
    /**
     * Per requirements: "when drag starts on something that is not selected, make it selected and deselect anything not selected"
     *
     * See https://github.com/SHOFLO/Issues/issues/1986
     */
    const isMultiSelected = selectedItemIds.indexOf(item._id) >= 0;
    if (!isMultiSelected) {
      //TODO: props.selectObject(item._id);
      selectedItemIds = [item._id];
    }

    return {
      item,
      selectedItemIds,
    };
  },
};

const dragCollect = (connect, monitor) => {
  const item = monitor.getItem();

  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    draggingItemIds: item ? item.selectedItemIds : null,
  };
};

function dropCollect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    isOverCurrent: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
  };
}

const listItemTarget = {
  canDrop(props, monitor) {
    const { item } = props;

    return item.isDirectory && item._id !== monitor.getItem().item._id;
  },

  drop(props, monitor) {
    if (monitor.didDrop()) {
      return;
    }

    const { item, onDrop } = props;

    const monitorItem = monitor.getItem();
    const objectToMoveId = monitorItem.item._id;
    const parentTargetId = item._id;

    if (parentTargetId === objectToMoveId) return;

    let objectIdsToMove = [objectToMoveId];

    if (monitorItem.selectedItemIds && monitorItem.selectedItemIds.length) {
      objectIdsToMove = monitorItem.selectedItemIds;
    }

    onDrop(objectIdsToMove, parentTargetId);
  },
};

export { listItemDragSource, listItemTarget, dropCollect, dragCollect };
